<template>
  <div class="mx-3">
    <div id="ExecutiveSummaryRef">
      <ValidationObserver ref="ExecutiveSummaryRef" v-slot="{}" tag="form">
        <div class="additional-container">
          <div class="py-3 px-1 pl-c-xl">
            <icon-view
              icon="fas fa-info-circle"
              icon-background="transparent"
              icon-color="#FF7058"
              icon-size="1.0625rem"
              :title="sectionTitle"
              variant="custom-icon"
            />
          </div>
        </div>
        <div
          v-for="(item, index) in questionsData"
          :key="index"
          class="row mt-3 mb-4"
        >
          <div
            v-if="!item.groupComponent"
            class="col-12 my-3 color-gray-6 font-16 text-justify"
          >
            {{ item.question }}
          </div>
          <div v-if="!item.groupComponent" class="col-12">
            <ValidationProvider
              v-slot="{ errors }"
              rules="required|hasValidCommentSize"
            >
              <span v-if="isReadOnly" class="data-content d-block text-justify">
                {{ item.answer | empty }}
              </span>
              <custom-text-area
                v-else
                v-model="item.answer"
                :count-classes="['float-right']"
                :custom-error-msg="item.validationMessage"
                :disabled="isReadOnly"
                :error="errors[0]"
                :maxlength="3000"
                placeholder="Escribe un comentario"
                :prevent-enter="true"
                :show-char-count="!isReadOnly"
                @input="getComment(index, $event)"
              />
            </ValidationProvider>
          </div>
          <div class="container-fluid">
            <div
              v-if="item.groupComponent && isHeadElement(item)"
              class="row mt-3 mb-4"
            >
              <div
                v-for="(itemGroup, indexGroup) in questionDataByGroup"
                :key="indexGroup"
                :class="[
                  'mb-4',
                  itemGroup.width !== null ? `col-${itemGroup.width}` : 'col',
                  !itemGroup.canShowPlaceHolder ? 'align-content-end' : '',
                ]"
              >
                <div
                  v-if="itemGroup.canShowPlaceHolder"
                  class="my-3 color-gray-6 font-16 text-justify"
                >
                  {{ itemGroup.question }}
                </div>
                <div class="mt-3 mb-4">
                  <ValidationProvider v-slot="{ errors }" rules="required">
                    <span
                      v-if="isReadOnly"
                      class="data-content d-block text-justify"
                    >
                      {{ itemGroup.answer | empty }}
                    </span>
                    <component
                      :is="getComponentName(itemGroup.questionType)"
                      v-else
                      v-model="itemGroup.answer"
                      :custom-error-msg="itemGroup.validationMessage"
                      :disabled="isReadOnly"
                      :error="errors[0]"
                      fieldkey="id"
                      fieldname="name"
                      :options="timeOptions"
                      :placeholder="itemGroup.placeHolder"
                      :type="getInputType(itemGroup.questionType)"
                    />
                  </ValidationProvider>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="isReadOnly" class="col-12">
          <hr />
        </div>
        <div class="mt-3 mb-3 align-items-center d-flex justify-content-end">
          <action-button
            v-if="!isReadOnly"
            id="btnCancel"
            :disabled="isReadOnly"
            i="fas fa-times-circle"
            text="Cancelar"
            variant="outline-danger mr-3 pl-3 pr-4"
            @click="onCancel"
          />
          <action-button
            v-if="!isReadOnly"
            id="btnSave"
            i="fas fa-flag pr-2"
            text="Someter"
            variant="success px-3"
            @click="onSaveHandler"
          />
        </div>
        <div class="col-12">
          <custom-modal
            cancel-text="Cancelar"
            icon="fas fa-exclamation-circle"
            is-centered
            :save-icon="'fas fa-flag pr-2'"
            save-text="Someter"
            show-cancel
            show-save
            title="Someter"
            :value="showModal"
            width="850px"
            @cancel="onCancelAcceptTermHandler"
            @save="onSubmit"
          >
            <custom-checkbox-single-option
              id="custom-checkbox-acceptedTerms"
              v-model="acceptedTerms"
              class="font-16"
              option-text="Acepto los términos y responsabilidades"
              title="Certifico que la información ofrecida es cierta y correcta"
            />
          </custom-modal>
        </div>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import CustomTextArea from 'CustomTextArea';
import IconView from 'icon-view';
import ActionButton from 'ActionButton';
import CustomModal from 'CustomModal';
import CustomCheckboxSingleOption from 'custom-checkbox-single-option';
import { submitAnswer as _submitAnswer } from '@/services/provider/provider-question.js';
import providerQuestionSection from '@/utils/constants/providerQuestionSection';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';
import providerProfileStates from '@/utils/constants/ProviderProfileStates';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import providerQuestion from '@/utils/constants/providerQuestion';
import CustomInput from 'CustomInput';
import CustomDropDown from 'custom-drop-down';

export default {
  name: 'ExecutiveSummary',
  components: {
    CustomTextArea,
    IconView,
    ActionButton,
    CustomModal,
    CustomCheckboxSingleOption,
    ValidationObserver,
    ValidationProvider,
    CustomInput,
    CustomDropDown,
  },
  mixins: [alertMixin],
  async mounted() {
    if (
      [
        providerProfileStates.Submitted,
        providerProfileStates.Approved,
        providerProfileStates.Denied,
      ].includes(this.statusId)
    ) {
      if (this.questions && this.questions.length > 0) {
        this.questionsData = this.questions.map((item) => ({
          ...item,
          answer: item.answers?.[0]?.answer || '',
        }));
      }
    } else {
      this.questionsData = this.questions.map((item) => ({
        ...item,
        answer: '',
      }));
    }
    this.questionDataByGroup = this.questionsData.filter(
      (q) => q.groupComponent !== null
    );
  },
  data: () => ({
    questionsData: [],
    questionDataByGroup: [],
    showModal: false,
    acceptedTerms: false,
  }),
  computed: {
    isReadOnly() {
      return (
        this.statusId == providerProfileStates.Submitted ||
        this.statusId == providerProfileStates.Approved
      );
    },
  },

  props: {
    providerId: {
      type: Number,
      default: () => 0,
    },
    biddingAcademicYearId: {
      type: Number,
      default: () => 0,
    },
    statusId: {
      type: Number,
      default: () => 0,
    },
    sectionTitle: {
      type: String,
      default: () => '',
    },
    questions: {
      type: Array,
      default: () => [],
    },
    timeOptions: {
      type: Array,
      default: () => [
        { id: 'Días', name: 'Días' },
        { id: 'Meses', name: 'Meses' },
        { id: 'Años', name: 'Años' },
      ],
    },
  },
  methods: {
    isProfession(questionid) {
      return questionid == providerQuestion.Profession;
    },
    getComment(i, value) {
      this.questionsData[i].answer = value;
    },
    clean() {
      this.questionsData = [];
      this.showModal = false;
      this.acceptedTerms = false;
    },
    async onCancel() {
      if (this.statusId != providerProfileStates.Denied) {
        const answer = await this.ShowCancelModal(
          'Confirmación',
          `¿Está seguro de que desea cancelar? Si cancela, se borrarán todos los datos que ha llenado en esta sección.`,
          'Sí',
          'No'
        );

        if (answer) {
          this.clean();
          this.$emit('on-cancel');
        } else {
          return;
        }
      } else {
        this.$emit('on-cancel');
      }
    },
    async onSaveHandler() {
      const isValid = await this.$refs.ExecutiveSummaryRef.validate();
      if (isValid) {
        this.showModal = true;
      } else {
        this.ShowToast('Alerta', 'Información Incompleta', 'error');
        return;
      }
    },
    async onCancelAcceptTermHandler() {
      this.showModal = false;
      this.acceptedTerms = false;
    },
    async onSubmit() {
      if (!this.acceptedTerms) {
        this.ShowToast(
          'Alerta',
          'Favor aceptar los términos y responsabilidades.',
          'error'
        );
        return;
      }

      this.questionsData = this.questionsData.map((item) => {
        if (item.answer.id) {
          item.answer = item.answer.name;
        }
        return item;
      });

      const payload = {
        sectionId: providerQuestionSection.ExecutiveSummary,
        providerId: this.providerId,
        academicYearId: this.biddingAcademicYearId,
        statusId: providerProfileStates.Submitted,
        answers: this.questionsData
          .filter((item) => item.answer.trim() !== '')
          .map((item) => ({
            questionId: item.id,
            answer: item.answer,
          })),
      };

      const { data: response } = await _submitAnswer(payload);
      if (response) {
        this.ShowToast(
          'Confirmación',
          'El estatus ha sido actualizado exitosamente.',
          'success'
        );
        this.$emit('on-save');
      } else {
        this.ShowToast('Error', response?.data?.message || 'error', 'error');
      }

      this.showModal = false;
      this.acceptedTerms = false;
    },
    isHeadElement(element) {
      let minOrderId = this.questionDataByGroup[0];

      this.questionDataByGroup.forEach((el) => {
        if (el.sortOrder !== null && el.sortOrder < minOrderId.sortOrder) {
          minOrderId = el.sortOrder;
        }
      });
      return element.sortOrder == minOrderId.sortOrder;
    },
    getComponentName(type) {
      switch (type) {
        case 1:
          return 'custom-input';
        case 2:
          return 'custom-drop-down';
        case 3:
          return 'custom-input';
      }
    },
    getInputType(questionType) {
      switch (questionType) {
        case 1:
          return 'text';
        case 2:
          return 'text';
        case 3:
          return 'number';
      }
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .custom-icon {
  .dot {
    box-shadow: none !important;
    margin-right: 4px !important;
  }
  .dot.dot--has-border {
    border-color: transparent !important;
  }
  .color-gray-7.font-16.font-weight-bold {
    color: #11291b !important;
  }
}
</style>
